import React from 'react';
import stylesOp from "../../../../../pages/OperationDetailPage/_components/Operation/style.module.scss";
import {
    getStatusOpName,
    OP_STATUS,
    OPERATION_TYPE,
    transportSteps
} from "../../../../../util/varibles/constants";
import { IOperation2, ITransport2 } from "../../../../../util/varibles/interface";
import SiteDisease from "../../../../Operation/FishDisease/SiteDisease";
import TankDensities from "../../../../Operation/TankDensities";
import Header from "../../Header";
import { callEventPopupOpInfo } from '../../PopupOpInfoContext';
import ActivityLog from "../../_component/AcitivtyLog";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import BoxOpInfo from "../../_component/BoxOpInfo";
import Columns from "../../_component/Columns";
import Duration from "../../_component/Duration";
import Status from "../../_component/Status";
import { getSubOfTransport } from "../../constants";
import stylesContainer from "../../style.module.scss";
import TransportInfo from "./TransportInfo";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<ITransport2>
}

const Transport: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const { updateNote, changeState } = callEventPopupOpInfo();

    const { operation, activity_log } = data;

    const {
        current_process,
        total_weight = 1,
        sub_operations = [],
        sub_destinations = [],
        status,
        diseases
    } = operation;

    const { sub, total } = getSubOfTransport(sub_operations, sub_destinations);
    const statusText = status === OP_STATUS.PROCESSING ? transportSteps[current_process]?.name : getStatusOpName(status);

    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className={stylesContainer['header-id']}>
                    <div className='ml-3'>
                        <Status {...{ status, statusText }} />
                    </div>
                    <div className='ml-3'>
                        Total weight:
                        <b className='ml-1'>{Math.round(total_weight / 1000) / 1000} t</b>
                    </div>
                </div>
            </div>
        </Header>

        <div className={stylesContainer.body}>
            <ActivityLog />

            <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
                <Columns className="mb-2" content={[
                    <>
                        <Duration activity_log={activity_log} />
                        <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
                        <Approver operation={operation} />
                    </>,
                    <SiteDisease diseases={operation.diseases || []} />
                ]} />
                <div className={stylesOp['info-line']}>
                    <TankDensities type={OPERATION_TYPE.TRANSPORT} storages={sub_destinations[0]?.storages} />
                </div>
                <TransportInfo {...{ data: sub, total, diseases }} />
            </BoxOpInfo>
        </div>
    </>
};

export default Transport;
